module.exports = __webpack_public_path__ + "img/picture-1.27a07238.webp";